import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const Login = () => {
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        rememberMe: false,
    });
    const [error, setErrors] = useState({});
    const navigate = useNavigate();
    const auth = useAuth();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        validateForm(formData);
    };

    const validateForm = (data) => {
        const errors = {};

        if (!data.username.trim()) {
            errors.username = "Username is required";
        } else if (data.username.length < 4) {
            errors.username = "Username must be at least 4 characters long";
        }

        if (!data.password) {
            errors.password = "Password is required";
        } else if (data.password.length < 8) {
            errors.password = "Password must be at least 8 characters long";
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = validateForm(formData);
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            auth.loginAction({ username: formData.username, password: formData.password });
            return;
        } else {
            console.log(error);
        }
    };

    const handleForgetPassword = (e) => {
        navigate("/forget-password");
    };

    const [passwordVisible, setPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
      };
    
      const onPasswordMouseDown = () => {
        setPasswordVisible(true);
      };
    
      const onPasswordMouseUp = () => {
        setPasswordVisible(false);
      };

    return (
        <div className="container min-vh-100 d-grid">
            <div className="row">
                <div className="col-lg-5 col-md-8 m-auto">
                    <div className="login-wrapper">
                        <div className="section-content text-center mb-2">
                            <img src={require("../assets/img/gb-logo.jpg")} alt="Logo" style={{ width: "90px" }} />
                            <p className="desc-content">Please login using account detail below.</p>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <input name="username" type="text" placeholder="Username" className="form-control" value={formData.username} onChange={handleChange} />
                                {error && <p className="text-xs text-danger">{error.username}</p>}
                            </div>
                            <div className="mb-3">
                                <input name="password" type={passwordVisible ? "text" : "password"} placeholder="Password" className="form-control" value={formData.password} onChange={handleChange} />
                                {/* <span className="eye-icon" onMouseDown={onPasswordMouseDown} onMouseUp={onPasswordMouseUp} >
                                    {passwordVisible ? '👁️' : '👁️‍🗨️'}
                                </span> */}
                                {error && <p className="text-xs text-danger">{error.password}</p>}
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="mb-3 form-check">
                                    <input type="checkbox" className="form-check-input" id="rememberMe" name="rememberMe" value={formData.rememberMe} onChange={(e) => setFormData({ ...formData, rememberMe: e.target.checked })}></input>
                                    <label className="form-check-label" htmlFor="rememberMe">
                                        remember me
                                    </label>
                                </div>
                                <button type="button" className="btn btn-link mb-3" onClick={handleForgetPassword}>
                                    Forget Password?
                                </button>
                            </div>
                            <div className="mb-3 d-grid col-12">
                                <button className="btn btn-dark" type="submit">
                                    Sign in
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
